module.exports = __webpack_public_path__ + "img/bitrue-view-small.7f20ee87.png";